import { create } from "zustand";

import type { AuthSheetMode } from "../../../component-library/auth-sheet/AuthSheet.js";

type AuthSheetState = {
  isOpen: boolean;
  mode: AuthSheetMode;
  openAuthSheet: (mode?: AuthSheetMode) => void;
  closeAuthSheet: () => void;
  setAuthSheetMode: (mode: AuthSheetMode) => void;
};

export const useAuthSheetStore = create<AuthSheetState>((set) => ({
  isOpen: false,
  mode: "login",
  openAuthSheet(mode = "login") {
    set({ isOpen: true, mode });
  },
  closeAuthSheet() {
    set({ isOpen: false });
  },
  setAuthSheetMode(mode) {
    set({ mode });
  },
}));
